export const TABLE = 'table';
export const T_R = 'tr';
export const T_H = 'th';
export const T_D = 'td';
